export const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect width="28" height="28" rx="14" fill="#8138FF" />
    <path
      d="M7.25 10.25C7.25 9.85218 7.40804 9.47064 7.68934 9.18934C7.97064 8.90804 8.35218 8.75 8.75 8.75H19.25C19.6478 8.75 20.0294 8.90804 20.3107 9.18934C20.592 9.47064 20.75 9.85218 20.75 10.25V17.75C20.75 18.1478 20.592 18.5294 20.3107 18.8107C20.0294 19.092 19.6478 19.25 19.25 19.25H8.75C8.35218 19.25 7.97064 19.092 7.68934 18.8107C7.40804 18.5294 7.25 18.1478 7.25 17.75V10.25Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.25 10.25L14 14.75L20.75 10.25"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
